import { useEffect, useRef } from "react";

// Rails (Channel#min_guest_age_must_be_allowed) rejects a bad value with a 422
// whose body is `{ success: false, error: "Min guest age must be one of ..." }`:
// the full messages joined into one string, not a per-field map.
export const minGuestAgeErrorMessage = (errors) => {
  const message = errors && typeof errors === "object" ? errors.error : null;
  return typeof message === "string" && /min guest age/i.test(message)
    ? message
    : null;
};

// Pins a rejected save's min-guest-age message to its control, since the save
// saga only toasts the failure.
// `ignoreInitial`: the editor opens with whatever the store still holds from a
// previous channel's save; that stale rejection must not mark this form.
export const useMinGuestAgeServerError = (form, errors, ignoreInitial = false) => {
  const initial = useRef(errors);
  useEffect(() => {
    if (ignoreInitial && errors === initial.current) return;
    const message = minGuestAgeErrorMessage(errors);
    if (message) form.setError("min_guest_age", { type: "server", message });
  }, [errors]);
};
